import React from 'react';
import { useTranslation } from 'react-i18next';
import { CommonDialog } from '../shared/dialog/CommonDialog';

export const BlockSucceededDialog: React.FC = () => {
  const { t } = useTranslation(['best_friends', 'translation']);
  const title = t('dialog_cut_off_success');
  const description = t('delete_complete');
  return <CommonDialog title={title} description={description} />;
};
